import { createTheme } from '@mui/material/styles';

import colors from '../tokens/colors';
import { getoloFontFamily } from '../tokens/fonts';
import typography from '../tokens/typography/getolo';

// base component styles
import { accordionGetolo } from '../components/accordion.style';
import { autocompleteGetolo } from '../components/autocomplete.style';
import { buttonGetolo } from '../components/button.style';
import { checkboxGetolo } from '../components/checkbox.style';
import { emailGetolo } from '../components/email.style';
import { inputGetolo } from '../components/input.style';
import { linkGetolo } from '../components/link.style';
import { listGetolo } from '../components/list.style';
import { phoneGetolo } from '../components/phone.style';
import { radioGetolo } from '../components/radio.style';
import { selectGetolo } from '../components/select.style';
import { toggleSwitchGetolo } from '../components/toggleSwitch.style';

// widget styles
import { backButtonGetolo } from '../widgets/backButton.style';
import { formLabelGetolo } from '../widgets/formLabel.style';
import { informationTextGetolo } from '../widgets/informationText.style';
import { pageHeaderGetolo } from '../widgets/pageHeader.style';
import { priceButtonGetolo } from '../widgets/priceButton.style';

// mui overrides
import muiAccordionOverride from '../overrides/accordion.override';
import muiAutocompleteOverride from '../overrides/autocomplete.override';
import muiCheckboxOverride from '../overrides/checkbox.override';
import muiSelectOverride from '../overrides/select.override';

export const muiFocused = 'Mui-focused';
export const muiFocusVisible = 'Mui-focusVisible';
export const muiDisabled = 'Mui-disabled';

const theme = createTheme({
  palette: {
    main: {
      professional_blue: colors.PROFESSIONAL_BLUE,
      professional_light_blue: colors.PROFESSIONAL_LIGHT_BLUE,
      product_blue: colors.PRODUCT_BLUE,
    },
    neutral: {
      gray: colors.GRAY,
      light_gray: colors.LIGHT_GRAY,
      ultra_light_gray: colors.ULTRA_LIGHT_GRAY,
      black: colors.BLACK,
      white: colors.WHITE,
    },
    error: {
      main: colors.ERROR_RED,
    },
    success: {
      main: colors.SUCCESS_GREEN,
    },
  },
  breakpoints: {
    values: {
      // preserve MUI defaults because MUI components break without this (eg. Dialog)
      ...createTheme().breakpoints.values,

      // tyrion breakpoints
      mobile: 0,
      tablet: 376,
      desktop: 973,
    },
  },
  shadows: [
    'none',
    '0 0 10px 0 rgba(0,0,0,0.1)',
    'none', // button shadow
    'none', // input/select shadow
    'none', // radio/checkbox shadow
    '0 0 15px 0 rgba(0, 0, 0, 0.1)', // accordion shadow
    '0 0 10px 0 rgba(0, 0, 0, 0.1)', // radio button card shadow
    '0 0 5px rgba(0, 0, 0, 0.1)', // chat box shadow
  ],
  typography: {
    fontFamily: getoloFontFamily,
    ...typography,
  },
  components: {
    accordion: accordionGetolo,
    autocomplete: autocompleteGetolo,
    button: buttonGetolo,
    checkbox: checkboxGetolo,
    email: emailGetolo,
    input: inputGetolo,
    link: linkGetolo,
    list: listGetolo,
    phone: phoneGetolo,
    radio: radioGetolo,
    select: selectGetolo,
    toggleSwitch: toggleSwitchGetolo,

    MuiAccordion: muiAccordionOverride,
    MuiAutocomplete: muiAutocompleteOverride,
    MuiCheckbox: muiCheckboxOverride,
    MuiSelect: muiSelectOverride,
  },
  widgets: {
    backButton: backButtonGetolo,
    daDirektCode: {},
    formLabel: formLabelGetolo,
    informationText: informationTextGetolo,
    pageHeader: pageHeaderGetolo,
    priceButton: priceButtonGetolo,
  },
  // spacing: 8, // Sets base spacing unit (optional, default is 8px)
});

export default theme;
